/**
 * @desc 报表模块
 */

const statistical = (r) =>
  require.ensure(
    [],
    () => r(require('../views/report/statistical.vue')),
    'statistical'
  )

const teacherAttend = (r) =>
  require.ensure(
    [],
    () => r(require('../views/report/teacherAttend.vue')),
    'teacherAttend'
  )

  const workDetail = (r) =>
  require.ensure(
    [],
    () => r(require('../views/report/workDetail.vue')),
    'workDetail'
  )
  
const studentAttend = (r) =>
  require.ensure(
    [],
    () => r(require('../views/report/studentAttend.vue')),
    'studentAttend'
  )

export default [
  {
    // 课时明细
    name: 'statistical',
    path: '/statistical',
    component: statistical,
    meta: { title: '课时明细' },
  },
  {
    // 老师考勤
    name: 'teacherAttend',
    path: '/teacherAttend',
    component: teacherAttend,
    meta: { title: '考勤汇总', keepAlive: true },
  },
  {
    // 老师考勤
    name: 'workDetail',
    path: '/workDetail',
    component: workDetail,
    meta: { title: '考勤明细', keepAlive: true },
  },
  {
    // 学生出勤
    name: 'studentAttend',
    path: '/studentAttend',
    component: studentAttend,
    meta: { title: '学生出勤' },
  },
]
